import React from 'react';
import './PicBar.css';
import Picture from './assets/vegetable.jpg';
import { Link } from 'react-router-dom';


const PicBar = ({ setPagePosition }) => (


  <div className="PicBar">




    <img className="Picture" src={Picture} alt="Test"></img>

      <p className="center-left">Praxis für Ernährungsberatung & Ernährungstherapie</p>
      <p className="center-left2">Katja Bär-Hanuja</p>


    <Link to = "Nachricht" className="OffersOnline"><span className="Auch">Auch  </span><span className="OnlineBeratung" onClick={() => { setPagePosition(11); }}>Online Beratung  </span>
    </Link>






  </div>
);

export default PicBar;